import Swiper from 'swiper'
import threeColumnSliderInit from '../partials/three-column-slider'
import fullWidthSliderInit from '../partials/full-width-slider'
import headerScrollWhite from '../partials/headerWhite'
import partnersSlider from '../partials/partners-slider'

export default {
  init() {
    window.onscroll = headerScrollWhite;
    fullWidthSliderInit();
    threeColumnSliderInit();

    //Video Button Actions
    $('.play').on('click', function () {
      $(this).css({'opacity':'0', 'z-index': '-1'});
      $(this).parent().find('.pause').addClass('visible');
      $(this).parent().find('video').get(0).play();
    });
    $('.pause').on('click', function () {
      $(this).removeClass('visible');
      $(this).parent().find('.play').css({'opacity':'1', 'z-index': '1'});
      $(this).parent().find('video').get(0).pause();
    });

    // Review Sliders
    // eslint-disable-next-line
    let customersReviews = new Swiper ('.customers-review__slider', {
      effect: 'fade',
      simulateTouch: false,
      fadeEffect: {
        crossFade: true,
      },
      scrollbar: {
        el: '.author-slider-scrollbar',
        hide: false,
        draggable: true,
      },
    });

    // eslint-disable-next-line
    let authorSlider = new Swiper ('.author-slider', {
      effect: 'fade',
      simulateTouch: false,
      fadeEffect: {
        crossFade: true,
      },
      scrollbar: {
        el: '.author-slider-scrollbar',
        hide: false,
        draggable: true,
      },
    });

    partnersSlider();
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js